import { ReactNode } from 'react';
import { TextColorType } from '../../shared/types/textColor.types';

const Sizing = {
  Regular: 'regular',
  Small: 'small',
  Inherit: 'inherit',
} as const;

type SizingType = typeof Sizing[keyof typeof Sizing];

export default interface TextProps {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  sizing?: SizingType;
  className?: string;
  color?: TextColorType;
  dataCy?: string;
  children?: string | ReactNode;
}

export { Sizing, SizingType };
